// extracted by mini-css-extract-plugin
export default {"ImageContainer":"EmptyScreen_ImageContainer__hg0gW"};